export var NielsenEventType = /*#__PURE__*/ function(NielsenEventType) {
    NielsenEventType["Complete"] = "complete";
    NielsenEventType["Playhead"] = "playhead";
    return NielsenEventType;
}({});
export var NielsenContentType = /*#__PURE__*/ function(NielsenContentType) {
    NielsenContentType["Ad"] = "ad";
    NielsenContentType["Content"] = "content";
    return NielsenContentType;
}({});
export var NielsenIsFullEpisode = /*#__PURE__*/ function(NielsenIsFullEpisode) {
    NielsenIsFullEpisode[NielsenIsFullEpisode["Live"] = 1] = "Live";
    NielsenIsFullEpisode[NielsenIsFullEpisode["VOD"] = 1] = "VOD";
    NielsenIsFullEpisode[NielsenIsFullEpisode["Advert"] = 0] = "Advert";
    NielsenIsFullEpisode[NielsenIsFullEpisode["SingleLiveEvent"] = 1] = "SingleLiveEvent";
    NielsenIsFullEpisode[NielsenIsFullEpisode["Preview"] = 0] = "Preview";
    NielsenIsFullEpisode[NielsenIsFullEpisode["Clip"] = 0] = "Clip";
    NielsenIsFullEpisode[NielsenIsFullEpisode["FER"] = 1] = "FER";
    return NielsenIsFullEpisode;
}({});

//# sourceMappingURL=nielsen-api.enums.js.map